// Angular
import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef, Inject, ViewRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
// RxJS
import { Observable, BehaviorSubject, Subscription, ReplaySubject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
// NGRX
// Service
import { SubheaderService } from '../../../../../core/_base/layout';
import { LayoutUtilsService, MessageType } from '../../../../../core/_base/crud';
import { PhuLieuService } from '../phu-lieu-service/phu-lieu.service';
//Models
import { FileImportHH, PhuLieuModel } from '../phu-lieu-model/phu-lieu.model';
import { ListImageModel } from '../phu-lieu-model/phu-lieu.model';
import { DungChungService } from '../../dung-chung/__services/dung-chung.service'
import { FunctionPublic } from './../../dung-chung/__function/common_function';
import { ContentComponent } from 'app/views/pages/components/content-component/content-component.component';
import { NCC_MOQ } from '../../nguyen-lieu/nguyen-lieu-model/nguyen-lieu.model';
import { CommonConFig } from '../../dung-chung/__model/common_config.model';
import { ProductStatusText } from '../../../../../shared/constants/product-status.constant';
import { ProductStatus } from '../../../../../shared/enums/product-status.enum';
@Component({
	selector: 'kt-phu-lieu-edit',
	templateUrl: './phu-lieu-edit.component.html',
	styleUrls: ['../phu-lieu.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhuLieuEditComponent implements OnInit, OnDestroy {
	/*----------------------------Config Form ---------------------------*/
	CONFIG: CommonConFig;
	/* ------------------------------------------------------------------*/

	// Public properties
	@ViewChild('fileUpload', { static: true }) fileUpload;
	PhuLieu: PhuLieuModel;
	PhuLieuForm: FormGroup;
	hasFormErrors: boolean = false;
	loadingSubject = new BehaviorSubject<boolean>(true);
	loading$: Observable<boolean>;
	viewLoading: boolean = false;
	isChange: boolean = false;
	fixedPoint = 2;
	isZoomSize: boolean = false;
	flagFileImport: FileImportHH = new FileImportHH();
	flagFileDownload: any;
	tmpDVT1 : any;
	listId_NhomHH: any[] = [];
	selectId_NhomHH: string = '0';

	listDVT1: any[] = [];
	selectDVT1: string = '0';
	selectDVT2: string = '0';
	selectDVT3: string = '0';
	listBoPhanKiemTra: any[] = [];
	selectBoPhanKiemTra: string = '0';
	selectBoPhanGiamSat: string = '0';

	listListNCC: any[] = [];
	selectListNCC: string[] = [];
	filteredListNCC: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListNCCFilterCtrl: string = '';
	haveElementListNCC: boolean = false;

	idLoaiHH = -1;

	IsValueRd: string = '';
	LinkAvatar: string = '';
	urlsDisplay = [];
	urlsSave = [];
	item: any;

	imageDaiDien: any;
	imgvlDaiDien: any;
	picDaiDien: ListImageModel[] = []

	imagedata: any;
	imgvl: any;
	listDongSanPham: any[] = [];

	tongFileChon: number = 0;

	private componentSubscriptions: Subscription;
	//list kho
	listKho: any[] = [];
	select_Kho: string[] = [];
	filtered_Kho: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Kho_FilterCtrl: string = '';
	haveElement_Kho: boolean = false;


	listNCC_MOQ: NCC_MOQ[] = [];
	displayedColumns = [];
	availableColumns = [
		{
			stt: 2,
			name: 'NCC',
			displayName: 'NCC',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'MOQ',
			displayName: 'MOQ',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'MOQ_dvt',
			displayName: 'Đơn vị tính MOQ',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 5,
			name: 'LeadTime',
			displayName: 'LeadTime',
			alwaysChecked: false,
			isShow: true
		},
		// {
		// 	stt: 99,
		// 	name: 'actions',
		// 	displayName: 'Thao tác',
		// 	alwaysChecked: true,
		// 	isShow: true
		// }
	];
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
  isLoading: boolean = false;
  statusText = ProductStatusText;
	constructor(
		public dialogRef: MatDialogRef<PhuLieuEditComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private PhuLieuFB: FormBuilder,
		public dialog: MatDialog,
		private layoutUtilsService: LayoutUtilsService,
		private changeDetectorRefs: ChangeDetectorRef,
		private phulieusService: PhuLieuService,
		private DungChungService: DungChungService,
		private changeDetect: ChangeDetectorRef
	) { dialogRef.disableClose = true; }
	/**
	 * On init
	 */
	ngOnInit() {
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();

		this.viewLoading = false;
		this.PhuLieu = this.data.data;
		this.idLoaiHH = this.data.idLoaiHH;
		this.tmpDVT1 = this.PhuLieu.DVT1;
		this.ListId_NhomHH(this.idLoaiHH);
		this.ListDVT1();
		this.ListBoPhanKiemTra();
		this.ListListNCC();
		this.loadListKho();
		this.ListDongSanPham();
		this.imagedata = {
			RowID: "",
			Title: "",
			Description: "",
			Required: false,
			Files: []
		}
		this.imageDaiDien = {
			RowID: "",
			Title: "",
			Description: "",
			Required: false,
			Files: []
		}
		if (this.PhuLieu.Id_HH > 0) {
			if (this.PhuLieu.listLinkImage.length > 0) {
				for (let i = 0; i < this.PhuLieu.listLinkImage.length; i++) {
					let a = {
						strBase64: "",
						filename: "",
						extension: "",
						Type: 1,
						type: "image/png",
						src: this.PhuLieu.domain + this.PhuLieu.listLinkImage[i].src,
						IsAdd: false,
						IsDel: false
					};
					this.imagedata.Files.push(a)
				}
			}
			if (this.PhuLieu.HinhDaiDien != null && this.PhuLieu.HinhDaiDien != '') {

				let a = {
					strBase64: "",
					filename: "",
					extension: "",
					Type: 1,
					type: "image/png",
					src: this.PhuLieu.domain + this.PhuLieu.HinhDaiDien,
					IsAdd: false,
					IsDel: false
				};
				this.imageDaiDien.Files.push(a)
				let tmpElement = new ListImageModel();
				tmpElement.clear();
				tmpElement.src = this.PhuLieu.domain + this.PhuLieu.HinhDaiDien;
				this.picDaiDien.push(tmpElement);
			}
		}

		this.createForm();
		this.PhuLieuForm.get("DVTThongKeTon").valueChanges.subscribe(
			(value) => {
				this.PhuLieuForm.controls["DVT2"].clearValidators();
				this.PhuLieuForm.controls['DVT2'].updateValueAndValidity();
				this.PhuLieuForm.controls["DVT3"].clearValidators();
				this.PhuLieuForm.controls['DVT3'].updateValueAndValidity();	
				if(value == "2"){
					this.PhuLieuForm.controls["DVT2"].setValidators(Validators.required);
					this.PhuLieuForm.controls['DVT2'].updateValueAndValidity();
				}
				else if(value == "3"){
					this.PhuLieuForm.controls["DVT3"].setValidators(Validators.required);
					this.PhuLieuForm.controls['DVT3'].updateValueAndValidity();
				}
				
			}
		);
		this.phulieusService.data_import.subscribe(res => {
			if (res != null && res != undefined) {
				for (let i = 0; i < res.length; i++) {
					this.flagFileImport = new FileImportHH();
					this.flagFileImport.clear();
					this.flagFileImport.filename = res[i].fileName;
					this.flagFileImport.extension = res[i].extension;
					this.flagFileImport.base64 = res[i].base64;
				}
			}
		});

		this.showColumnsInTable();
		this.applySelectedColumns();

		this.PhuLieuForm.controls.NCC.valueChanges.subscribe(() => {
			this.addDetail(1);
		})
	}
	/**
	 * On destroy
	 */
	ngOnDestroy() {
		if (this.componentSubscriptions) {
			this.componentSubscriptions.unsubscribe();
		}
	}
	/**
	 * Create form
	 */
	createForm() {
		// console.log("this.imageDaiDien.Files11",this.imageDaiDien.Files);
		this.PhuLieuForm = this.PhuLieuFB.group({
			maHH: [(this.PhuLieu.MaHH == null) ? '' : this.PhuLieu.MaHH, Validators.required],
			tenHH: [(this.PhuLieu.TenHH == null || this.PhuLieu.TenHH == '') ? '' : this.PhuLieu.TenHH, Validators.required],
			ghiChu: [(this.PhuLieu.GhiChu == null) ? '' : this.PhuLieu.GhiChu],
			ThoiHanSuDung: [(this.PhuLieu.ThoiHanSuDung == null) ? 0 : this.PhuLieu.ThoiHanSuDung, Validators.required],
			tonKhoToiThieu: [(this.PhuLieu.TonKhoToiThieu == null || this.PhuLieu.TonKhoToiThieu == '') ? '0.00' :
				this.f_currency(this.formatNumber(this.PhuLieu.TonKhoToiThieu))
			],
			dungSaiChoPhepNhap: [(this.PhuLieu.DungSaiChoPhepNhap == null || this.PhuLieu.DungSaiChoPhepNhap == '') ? '0.00' :
				this.f_currency(this.formatNumber(this.PhuLieu.DungSaiChoPhepNhap))
			],
			quyCachDongGoi: [(this.PhuLieu.QuyCachDongGoi == null) ? '' : this.PhuLieu.QuyCachDongGoi],
			dieuKienBaoQuan: [(this.PhuLieu.DieuKienBaoQuan == null) ? '' : this.PhuLieu.DieuKienBaoQuan],
			CanPhieuKt: [this.PhuLieu.CanPhieuKt],
			imageDaiDienControl: [this.imageDaiDien.Files],
			imageControl: [this.imagedata.Files],
			KhoMacDinh: [(this.PhuLieu.KhoMacDinh == null || this.PhuLieu.KhoMacDinh == '') ? '' : this.PhuLieu.KhoMacDinh.toString()],
			quyDoiDVT2: [(this.PhuLieu.QuyDoiDVT2 == null || this.PhuLieu.QuyDoiDVT2 == '') ? '0,00000' : this.f_dynamic(this.PhuLieu.QuyDoiDVT2)],
			quyDoiDVT3: [(this.PhuLieu.QuyDoiDVT3 == null || this.PhuLieu.QuyDoiDVT3 == '') ? '0,00000' : this.f_dynamic(this.PhuLieu.QuyDoiDVT3)],
			DVTThongKeTon: [(this.PhuLieu.DVTThongKeTon == null || this.PhuLieu.DVTThongKeTon == 0) ? 1 : this.PhuLieu.DVTThongKeTon.toString()],

			DVT1: [(this.PhuLieu.DVT1 == null || this.PhuLieu.DVT1 == 0) ? '' :
				this.PhuLieu.DVT1.toString(), Validators.required
			],
			DVT2: [(this.PhuLieu.DVT2 == null || this.PhuLieu.DVT2 == 0) ? '' :
				this.PhuLieu.DVT2.toString()
			],
			DVT3: [(this.PhuLieu.DVT3 == null || this.PhuLieu.DVT3 == 0) ? '' :
				this.PhuLieu.DVT3.toString()
			],
			NCC: [(this.PhuLieu.listNCC == null || this.PhuLieu.listNCC == []) ? '' :
				this.PhuLieu.listNCC
			],
			FileName: [(this.PhuLieu.TenFileGoc == null) ? '' : this.PhuLieu.TenFileGoc],
			idLoaiHH: [(this.PhuLieu.Id_NhomHH == null || this.PhuLieu.Id_NhomHH == 0) ? '' :
				this.PhuLieu.Id_NhomHH.toString(), Validators.required
			],
			DongSanPham: [(this.PhuLieu.DongSanPham == null || this.PhuLieu.DongSanPham == 0) ? '' :
				this.PhuLieu.DongSanPham.toString()],
			STATUS: [(this.PhuLieu.Status == null ? ProductStatus.Active : this.PhuLieu.Status.toString()), Validators.required],
		});
		//this.PhuLieuForm.controls['DVT1'].disable() //Nếu chỉnh sửa thì disable field đơn vị tính
		if (this.PhuLieu.Id_HH > 0) {
			this.selectId_NhomHH = '' + this.PhuLieu.Id_NhomHH;
			this.selectDVT1 = '' + this.PhuLieu.DVT1;
			this.selectDVT2 = '' + this.PhuLieu.DVT2;
			this.selectDVT3 = '' + this.PhuLieu.DVT3;
			this.selectBoPhanKiemTra = '' + this.PhuLieu.BoPhanKiemTra;
			this.selectBoPhanGiamSat = '' + this.PhuLieu.BoPhanGiamSat;
			if (this.PhuLieu.listNCC != null)
				this.PhuLieu.listNCC.forEach(NCC => {
					this.selectListNCC.push('' + NCC);
				})
			if (this.selectListNCC.length > 0) {
				this.haveElementListNCC = true;
			}
			this.addDetail();
		}
		
		// Dynamically switch the required validator for the field: 'quyDoiDVT2' based on the value of the fields 'DVT2'
		this.switchFieldRequire('DVT2', 'quyDoiDVT2');
		// Dynamically switch the required validator for the field: 'quyDoiDVT3' based on the value of the fields 'DVT3'
		this.switchFieldRequire('DVT3', 'quyDoiDVT3');

		this.changeDetectorRefs.detectChanges();

	}
	/**
	 * Returns page title
	 */
	getTitle(): string {
		if (this.PhuLieu.Id_HH == 0) {
			return 'Thêm mới phụ liệu';
		}
		return `Chỉnh sửa phụ liệu - ${this.PhuLieu.TenHH} `;
	}
	/**
	 * Check control is invalid
	 * @param controlName: string
	 */
	isControlInvalid(controlName: string): boolean {
		const control = this.PhuLieuForm.controls[controlName];
		const result = control.invalid && control.touched;
		return result;
	}
	/**
	 * Save data
	 *
	 * @param withBack: boolean
	 */
	onSubmit(type: boolean) {
    this.isLoading = true;
		this.hasFormErrors = false;
		const controls = this.PhuLieuForm.controls;
		/** check form */
		if (this.PhuLieuForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			this.hasFormErrors = true;
      this.isLoading = false;
			return;
		}
		


		// tslint:disable-next-line:prefer-const
		let editedPhuLieu = this.preparePhuLieus();
		if (this.PhuLieu.Id_HH > 0) {
			this.updatePhuLieu(editedPhuLieu)
			return;
		}
		this.addPhuLieu(editedPhuLieu, type);
	}
	/**
	 * Returns object for saving
	 */
	preparePhuLieus(): PhuLieuModel {

		const controls = this.PhuLieuForm.controls;
		const _PhuLieu = new PhuLieuModel();
		_PhuLieu.clear();
		_PhuLieu.Id_NhomHH = controls['idLoaiHH'].value;
		_PhuLieu.DVT1 = controls['DVT1'].value;
		_PhuLieu.DVT2 = controls['DVT2'].value;
		_PhuLieu.DVT3 = controls['DVT3'].value;
		_PhuLieu.BoPhanKiemTra = +this.selectBoPhanKiemTra;
		_PhuLieu.BoPhanGiamSat = +this.selectBoPhanGiamSat;
		_PhuLieu.listNCC = controls['NCC'].value;
		_PhuLieu.MaHH = controls['maHH'].value;
		_PhuLieu.TenHH = controls['tenHH'].value;
		_PhuLieu.GhiChu = controls['ghiChu'].value;
		_PhuLieu.TonKhoToiThieu = controls['tonKhoToiThieu'].value.replace(/,/g, "");
		_PhuLieu.DungSaiChoPhepNhap = controls['dungSaiChoPhepNhap'].value.replace(/,/g, "");
		_PhuLieu.QuyCachDongGoi = controls['quyCachDongGoi'].value;
		_PhuLieu.DieuKienBaoQuan = controls['dieuKienBaoQuan'].value;
		_PhuLieu.ThoiHanSuDung = controls['ThoiHanSuDung'].value;
		_PhuLieu.CanPhieuKt = controls['CanPhieuKt'].value;
		_PhuLieu.KhoMacDinh = controls['KhoMacDinh'].value == '' ? '0' : controls['KhoMacDinh'].value;
		_PhuLieu.QuyDoiDVT2 = controls['quyDoiDVT2'].value ? this.f_number(controls['quyDoiDVT2'].value) : '';
		_PhuLieu.QuyDoiDVT3 = controls['quyDoiDVT3'].value ? this.f_number(controls['quyDoiDVT3'].value) : '';
		_PhuLieu.DVTThongKeTon = 1;

		_PhuLieu.KhoMacDinh = controls['KhoMacDinh'].value == '' ? '0' : controls['KhoMacDinh'].value;
		_PhuLieu.Id_LHH = this.idLoaiHH.toString();
		_PhuLieu.FileImport = this.flagFileImport;
		_PhuLieu.File_TieuChuan = this.PhuLieu.File_TieuChuan;
		_PhuLieu.DongSanPham = controls['DongSanPham'].value ? +controls['DongSanPham'].value : null;
		this.imgvl = controls['imageControl'].value;
		_PhuLieu.listLinkImage = [];
    _PhuLieu.Status = Number(controls['STATUS'].value);

		this.imgvlDaiDien = controls['imageDaiDienControl'].value;

		this.listNCC_MOQ.map(x => x.filteredDVT_MOQ = null);
		_PhuLieu.listNCC_MOQ = this.listNCC_MOQ;

		if (this.imgvl.length > 0) {
			for (let i = 0; i < this.imgvl.length; i++) {
				const md = new ListImageModel();
				md.strBase64 = this.imgvl[i].strBase64;
				md.filename = this.imgvl[i].filename;
				md.src = this.imgvl[i].src;
				md.IsAdd = this.imgvl[i].IsAdd;
				md.IsDel = this.imgvl[i].IsDel;
				md.IsImagePresent = false;
				_PhuLieu.listLinkImage.push(md);
			}
		}

		if (this.imgvlDaiDien.length > 0) {
			for (let i = 0; i < this.imgvlDaiDien.length; i++) {
				const md = new ListImageModel();
				md.strBase64 = this.imgvlDaiDien[i].strBase64;
				md.filename = this.imgvlDaiDien[i].filename;
				md.src = this.imgvlDaiDien[i].src;
				md.IsAdd = this.imgvlDaiDien[i].IsAdd;
				md.IsDel = this.imgvlDaiDien[i].IsDel;
				md.IsImagePresent = true;
				_PhuLieu.listLinkImage.push(md);
			}
		}

		//gán lại giá trị id
		if (this.PhuLieu.Id_HH > 0) {
			_PhuLieu.Id_HH = this.PhuLieu.Id_HH;
		}
		return _PhuLieu;
	}
	/**
	 * Add item
	 *
	 * @param _PhuLieu: PhuLieuModel
	 * @param withBack: boolean
	 */
	addPhuLieu(_PhuLieu: PhuLieuModel, withBack: boolean = false) {
		this.phulieusService.createPhuLieu(_PhuLieu).subscribe({
      next: (res) => {
        this.isLoading = false;
        if (res.status == 1) {
          this.isChange = true;
          const message = `Phụ liệu mới đã được thêm.`;
          this.layoutUtilsService.showInfo(message);
          this.PhuLieuForm.reset();
          this.PhuLieu.clear();
          this.PhuLieu.DVT1 = this.tmpDVT1;
          this.createForm();
          this.selectBoPhanKiemTra = '';
          this.selectBoPhanGiamSat = '';
          this.changeDetectView();

          if (withBack)
            this.dialogRef.close({isChange: this.isChange});
        }
        else {
          this.layoutUtilsService.showErorr(res.error.message);
        }
      },
      error: (error) => {
        this.isLoading = false;
				this.layoutUtilsService.showErorr('Có lỗi xảy ra khi cập nhật phụ liệu');
      }
		});
	}
	/**
	 * Update item
	 *
	 * @param _PhuLieu: PhuLieusModel
	 * @param withBack: boolean
	 */
	updatePhuLieu(_PhuLieu: PhuLieuModel, withBack: boolean = false) {
		this.phulieusService.updatePhuLieu(_PhuLieu).subscribe({
      next: (res) => {
        this.isLoading = false;
        if (res.status == 1) {
          this.isChange = true;
          const message = `Phụ liệu đã được cập nhật`;
          this.layoutUtilsService.showInfo(message);
          this.dialogRef.close({isChange: this.isChange});
        }
        else {
          this.layoutUtilsService.showErorr(res.error.message);
        }
      },
      error: (error) => {
        this.isLoading = false;
				this.layoutUtilsService.showErorr('Có lỗi xảy ra khi thêm phụ liệu');
      }
		});
	}
	/**
	 * Close alert
	 *
	 * @param $event
	 */
	onAlertClose($event) {
		this.hasFormErrors = false;
	}
	numberOnly(event): boolean {
		const charCode = (event.which) ? event.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
		return true;
	}
	closeDialog() {
		this.dialogRef.close(this.isChange);
	}
	ListId_NhomHH(idLoaiHH: any) {
		this.phulieusService.listId_NhomHH(idLoaiHH).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listId_NhomHH = res.data;
				this.changeDetectorRefs.detectChanges();
			};
		});
	}
	ListDVT1() {
		this.phulieusService.listDVT1().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listDVT1 = res.data;
				this.changeDetectorRefs.detectChanges();
			};
		});
	}
	ListBoPhanKiemTra() {
		this.DungChungService.listPhongBanAll().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listBoPhanKiemTra = res.data;
				this.changeDetectorRefs.detectChanges();
			};
		});
	}
	ListListNCC() {
		this.phulieusService.listListNCC().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listListNCC = res.data;
				this.filteredListNCC.next(this.listListNCC.slice());
				this.changeDetectorRefs.detectChanges();
			};
		});
	}
	filterListNCC() {

		if (!this.listListNCC) {
			return;
		}
		// get the search keyword
		let search = this.ListNCCFilterCtrl;
		if (!search) {
			this.filteredListNCC.next(this.listListNCC.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredListNCC.next(
			this.listListNCC.filter(ts =>
				ts.TenNCC.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectorRefs.detectChanges();
	}
	SelectListNCC(event: any, dependOnField: string = '') {
		if (this.selectListNCC.length >= 0 && event.length > 0)
			this.haveElementListNCC = true;
		if (this.selectListNCC.length <= 1 && event.length == 0)
			this.haveElementListNCC = false;
		if (dependOnField != '') {
		}
	}
	ClearListNCC() {
		var controls = this.PhuLieuForm.controls;
		controls['NCC'].setValue('');

		this.changeDetectView();
	}
	ValidateChangeNumberEvent(event: any, isEvent: boolean = true) {
		var count = 0;
		if (isEvent) {
			for (let i = 0; i < event.target.value.length; i++) {
				if (event.target.value[i] == '.') {
					count += 1;
				}
			}
		}
		else {
			for (let i = 0; i < event.length; i++) {
				if (event[i] == '.') {
					count += 1;
				}
			}
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showInfo(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == '-1') return '';
		if (value == null || value == undefined || value == '') value = '0';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	changeValueOfForm(controlName: string, event: any) {
		if (this.ValidateChangeNumberEvent(event)) {
			let tmpValue = this.PhuLieuForm.controls[controlName].value.replace(/,/g, "");
			this.PhuLieuForm.controls[controlName].setValue(
				this.f_currency(this.formatNumber(tmpValue))
			);
		}
		else {
			this.PhuLieuForm.controls[controlName].setValue(event.target.value);
		}
	}
	f_convertDateTime(date: string) {
		var componentsDateTime = date.split("/");
		var date = componentsDateTime[0];
		var month = componentsDateTime[1];
		var year = componentsDateTime[2];
		var formatConvert = year + "-" + month + "-" + date + "T00:00:00.0000000";
		return new Date(formatConvert);
	}
	f_convertDate(p_Val: any) {
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return a.getFullYear() + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + ("0" + (a.getDate())).slice(-2);
	}
	resizeDialog() {
		if (!this.isZoomSize) {
			this.dialogRef.updateSize('100vw', '100vh');
			this.isZoomSize = true;
		}
		else if (this.isZoomSize) {
			this.dialogRef.updateSize('900px', 'auto');
			this.isZoomSize = false;
		}
	}
	showCachTaoMa() {
		// const _description: string = 'Đây là cách tạo mã cho phụ liệu';
		// this.layoutUtilsService.showInfo(_description);

		const dialogRef = this.dialog.open(ContentComponent);
		dialogRef.afterClosed().subscribe(res => {
			if (!res) { return; }
		});
	}
	//#region Kiểm tra định dạng số lượng
	keyUpInputKhoiLuong(event) {
		FunctionPublic.cvKeyUp(event);
	}
	ValidateChangeNumberForm(event: any, isEvent: boolean = true) {
		var count = 0;
		if (isEvent) {
			for (let i = 0; i < event.target.value.length; i++) {
				if (event.target.value[i] == ',') {
					count += 1;
				}
			}
		}
		else {
			event = "" + event
			for (let i = 0; i < event.length; i++) {
				if (event[i] == ',') {
					count += 1;
				}
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Số lượng không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Số lượng không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	f_number(item: any = "0.00000") {
		return FunctionPublic.F_NUMBER_DYNAMIC(item, 5);
	}
	changeInputOfFormVNDInList(columnName: string, event: any, min: number = 0, item: NCC_MOQ) {

		if (event.target.value == "") {
			event.target.value = this.f_number(0);
			event.target.selectionStart = 0;
			event.target.selectionEnd = 0;
		}

		if (event.target.value.toString() == item[columnName].toString()) {
			event.target.value = this.f_number(item[columnName]);
			event.target.selectionStart = 0;
			event.target.selectionEnd = 0;
		}

		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = event.target.value.replace(/\./g, "").replace(/,/g, ".");

			if (Number(tmpValue) < min) tmpValue = min;

			if (!item[columnName]) {
				item[columnName] = tmpValue.toString();
			}

			if (tmpValue.toString().indexOf(',') == 0 && tmpValue.toString().length == 1) {
				tmpValue = min;
			}
			item[columnName] = tmpValue.toString();
		}
		else {
			item[columnName] = min.toString();
		}

		this.changeDetectView();
	}

	loadListKho() {
		this.DungChungService.listKho().subscribe(res => {
			if (res && res.status == 1) {
				this.listKho = res.data;
				this.filtered_Kho.next(this.listKho.slice());
				this.changeDetectView();
			} else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		})
	}

	filterListKho() {

		if (!this.listKho) {
			return;
		}
		// get the search keyword
		let search = this.Kho_FilterCtrl;
		if (!search) {
			this.filtered_Kho.next(this.listKho.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filtered_Kho.next(
			this.listKho.filter(ts =>
				(ts.MaKho + ' - ' + ts.TenKho).toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}

	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}

	clearSelectKho(event: any) {
		this.PhuLieuForm.controls["KhoMacDinh"].setValue('');
		event.stopPropagation();
	}
	selectFile() {
		let el: HTMLElement = this.fileUpload.nativeElement as HTMLElement;
		el.click();
	}
	FileSelected(evt: any) {
		this.PhuLieu.File_TieuChuan = 0;
		if (evt.target.files && evt.target.files.length) {

			let fileNameList = [];
			for (let i = 0; i < evt.target.files.length; i++) {
				let file = evt.target.files[i];
				this.flagFileDownload = file;
				let fileName = file.name;
				fileNameList.push(fileName);
			}
			let listFileNameStr = fileNameList[0];
			for (var i = 1; i < fileNameList.length; i++) {
				listFileNameStr += ', ' + fileNameList[i];
			}
			this.PhuLieuForm.controls["FileName"].setValue(listFileNameStr);

			let el: any = this.fileUpload.nativeElement;
			var service = this.phulieusService;
			var useBase64: boolean = true;
			let tmpDataArray: any = [];

			for (var idx = 0; idx < el.files.length; idx++) {
				var extension = el.files[idx].name.split('.').pop();
				var fileName = el.files[idx].name.substring(0, el.files[idx].name.indexOf(extension) - 1);

				let reader = new FileReader();
				reader.readAsDataURL(el.files[idx]);
				reader.onload = function () {
					let base64Str = reader.result as String;
					var metaIdx = base64Str.indexOf(';base64,');

					base64Str = base64Str.substr(metaIdx + 8);
					var data = {
						fileName: fileName,
						base64: base64Str,
						extension: extension
					};

					tmpDataArray.push(data);
					service.data_import.next(tmpDataArray);
				};
			}
		}
		evt.target.type = 'text';
		evt.target.type = 'file';
	}

	ListDongSanPham() {
		this.phulieusService.listDongSanPham().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listDongSanPham = res.data;
				this.changeDetectorRefs.detectChanges();
			};
		});
	}


	/*--------- Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng------*/
	showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column)
				return i;
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}

	addDetail(type = 0) { //type 1: change in form, 0: from detail
		this.listNCC_MOQ = [];
		const controls = this.PhuLieuForm.controls;

		var listNCC = [];
		if (type == 0 && this.PhuLieu.Id_HH > 0 && (this.PhuLieu.listNCC_MOQ != null && this.PhuLieu.listNCC_MOQ.length > 0)) {
			this.PhuLieu.listNCC_MOQ.forEach(x => {
				var tmp = new NCC_MOQ();
				tmp.IdNCC = x.IdNCC;
				tmp.MaNCC = x.MaNCC;
				tmp.MOQ = x.MOQ;
				tmp.MOQ_dvt = x.MOQ_dvt;
				tmp.LeadTime = x.LeadTime;
				tmp.arrayIdDvt = [];
				tmp.filteredDVT_MOQ = new ReplaySubject<any[]>(1);;
				this.listNCC_MOQ.push(tmp);
			})

			// this.listNCC_MOQ = [...this.PhuLieu.listNCC_MOQ];
			setTimeout(() => {
				this.listNCC_MOQ.map(x => x.arrayIdDvt = [...this.listDVT1]);
				this.listNCC_MOQ.map(x => x.filteredDVT_MOQ.next(this.listDVT1.slice()));
				this.changeDetectView();
			}, 500);
		}
		else {
			if (controls['NCC'].value != '') {
				listNCC = controls['NCC'].value;
				listNCC.forEach(x => {
					let itemCT = new NCC_MOQ();
					itemCT.clear();

					let index = this.PhuLieu.listNCC_MOQ.findIndex(a => a.IdNCC == +x);
					if (index > -1) {
						itemCT.IdNCC = this.PhuLieu.listNCC_MOQ[index].IdNCC;
						itemCT.MaNCC = this.PhuLieu.listNCC_MOQ[index].MaNCC;
						itemCT.MOQ = this.PhuLieu.listNCC_MOQ[index].MOQ;
						itemCT.MOQ_dvt = this.PhuLieu.listNCC_MOQ[index].MOQ_dvt;
						itemCT.LeadTime = this.PhuLieu.listNCC_MOQ[index].LeadTime;

						itemCT.arrayIdDvt = [...this.listDVT1];
						itemCT.filteredDVT_MOQ.next(itemCT.arrayIdDvt.slice());

						this.listNCC_MOQ.push(itemCT);
						this.listNCC_MOQ = [...this.listNCC_MOQ];
					}
					else {
						let index = this.listListNCC.findIndex(a => a.Id_NCC == +x);
						if (index > -1) {
							itemCT.IdNCC = this.listListNCC[index].Id_NCC;
							itemCT.MaNCC = this.listListNCC[index].TenNCC;

							itemCT.arrayIdDvt = [...this.listDVT1];
							itemCT.filteredDVT_MOQ.next(itemCT.arrayIdDvt.slice());

							this.listNCC_MOQ.push(itemCT);
							this.listNCC_MOQ = [...this.listNCC_MOQ];
						}
					}
				})
			}
		}

		this.changeDetectView();
	}
	filterListDVT(item: NCC_MOQ) {
		if (!item.arrayIdDvt) {
			return;
		}
		// get the search keyword
		let search = item.DVT_MOQFilterCtrl;
		if (!search) {
			item.filteredDVT_MOQ.next(item.arrayIdDvt.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		item.filteredDVT_MOQ.next(
			item.arrayIdDvt.filter(ts =>
				(ts.TenDVT).toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}

	changeValueFormFourPoint(controlName: string, event: any) {
		let tmpValue = this.PhuLieuForm.controls[controlName].value.replace(/,/g, "");
		this.PhuLieuForm.controls[controlName].setValue(FunctionPublic.fmFourPoint(tmpValue, event));
	}

	changeInputOfForm(controlName: string, event: any, min: number = 0, formGroup) {
		const VALUE_EMPTY = "";
		const MIN_VALUE = min;
		const REGEX_COMMA = /,/g;
		const VALUE_DEFAULT = 0.00000;
		var controls = formGroup.controls;
		var valueControl = controls[controlName].value;
		// .. Giá trị trống thì lấy giá trị min
		if (valueControl == VALUE_EMPTY) controls[controlName].setValue(this.f_number(MIN_VALUE));
		// .. Giá trị không xác thực gán lại 0.0
		if (isNaN(valueControl)) valueControl = VALUE_DEFAULT;
		// .. Giá trị nhỏ hơn min thì = min
		if (Number(valueControl) < min) valueControl = MIN_VALUE;
		// .. Valid mới set giá trị
		if (!controls[controlName].invalid) controls[controlName].setValue(this.f_number(valueControl));
		// .. Giá trị "," thì gán về min
		if (valueControl.toString().indexOf(REGEX_COMMA) == 0 && valueControl.length == 1) valueControl = MIN_VALUE;
		controls[controlName].setValue(this.f_number(valueControl));
	}

	f_dynamic(item: any = "0.00000", dynamic = 5){
		return FunctionPublic.F_NUMBER_DYNAMIC(item, dynamic);
	}

	// Dynamically switch the required validator based on the value of another field
	switchFieldRequire(controlName: string, fieldRequire: string) {
		const form = this.PhuLieuForm.controls;

		// Check require if the controlName field has a value
		const required = form[controlName].value != '';

		// Set the validators for the fieldRequire control based on the value of controlName
		form[fieldRequire].setValidators(
			required ? Validators.compose([Validators.required, this.minValidator(0.00001)]) : null
		);

		// Update the validity status of the fieldRequire control
		form[fieldRequire].updateValueAndValidity();
	}

	// Custom validator function for minimum value
	minValidator(minValue: number) {
		return (control: AbstractControl): ValidationErrors | null => {
			// Extract the value from the form control and convert it to a number
			const value = this.f_number(control.value ? control.value : 0);

			// Check if the value is less than the minimum value
			if (value !== null && value !== undefined && value < minValue) {
				// If the value is less than the minimum value, return a validation error object
				return { min: true, actualValue: value, minValue: minValue };
			}

			// If the value is greater than or equal to the minimum value, return null (no validation error)
			return null;
		};
	}
}
